<label class="switch">
  <input id="switch" type="checkbox" [checked]="enabled" [disabled]="!allowChanges" (click)="handleToggle($event)" />
  <span class="slider round"></span>
</label>
